import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Package, ShoppingBag, Users, LogOut, Coffee, ExternalLink } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './AdminLayout.css';

const NAV_ITEMS = [
  { to: '/admin', label: 'Dashboard', icon: <LayoutDashboard size={18} />, end: true },
  { to: '/admin/products', label: 'Products', icon: <Package size={18} /> },
  { to: '/admin/orders', label: 'Orders', icon: <ShoppingBag size={18} /> },
  { to: '/admin/users', label: 'Users', icon: <Users size={18} /> },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <Coffee size={22} />
          <div>
            <span>Brew & Co</span>
            <small>Admin Panel</small>
          </div>
        </div>
        <div className="admin-user">
          <div className="admin-avatar">{user?.name?.[0]?.toUpperCase()}</div>
          <div>
            <p>{user?.name}</p>
            <span>Administrator</span>
          </div>
        </div>
        <nav className="admin-nav">
          {NAV_ITEMS.map(item => (
            <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}>
              {item.icon}
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="admin-footer">
          <a href="/" target="_blank" rel="noreferrer" className="admin-nav-item"><ExternalLink size={18} /> View Store</a>
          <button className="admin-nav-item logout" onClick={() => { logout(); navigate('/'); }}>
            <LogOut size={18} /> Sign Out
          </button>
        </div>
      </aside>
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}
